import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Link } from 'react-router-dom';
import { ModelOfBrand } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListBrandsController } from '../../controllers/Brands/ListBrandsController';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

const BrandsList: React.FC = () => {
	const { getBrandListController, handleBrandListController } = useListBrandsController();

	if (getBrandListController.loading) {
		return <LoadingScreen />;
	}

	const actionBodyTemplate = (brand: ModelOfBrand) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => handleBrandListController.openEditDialog(brand)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleBrandListController.openDeleteDialog(brand)}
				/>
			</React.Fragment>
		);
	};

	const editBrandDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleBrandListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getBrandListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const deleteBrandDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleBrandListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getBrandListController.selectedBrand &&
						handleBrandListController.removeBrand(getBrandListController.selectedBrand);
				}}
			/>
		</React.Fragment>
	);

	const leftBrandToolbar = () => {
		return (
			<Link to='/brandForm'>
				<Button label='Cadastrar marca' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	return (
		<div>
			<Toast ref={getBrandListController.toast} />
			<div className='p-card p-p-4 datatable-container'>
				<Toolbar className='p-mb-4' left={leftBrandToolbar}></Toolbar>

				<DataTable
					className='p-datatable-sm'
					dataKey='ID'
					rowHover
					scrollable
					scrollHeight="70vh"
					value={getBrandListController.brandsData}>
					<Column field='DESCRICAO' header='Marca'></Column>
					<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
				</DataTable>
			</div>

			<Dialog
				className='p-fluid'
				style={{ width: '450px' }}
				visible={getBrandListController.editDialog}
				onHide={handleBrandListController.closeEditDialog}
				onShow={() =>
					getBrandListController.formik.setFieldValue(
						'DESCRICAO',
						getBrandListController.selectedBrand?.DESCRICAO,
					)
				}
				footer={editBrandDialogFooter}
				header={`Editar marca ${getBrandListController.selectedBrand?.DESCRICAO}`}
				modal>
				<div className='p-field'>
					<label htmlFor='description'>Nome</label>
					<InputText
						id='name'
						type='text'
						value={getBrandListController.formik.values.DESCRICAO}
						onChange={getBrandListController.formik.handleChange('DESCRICAO')}
						required
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getBrandListController.formik.touched.DESCRICAO &&
								getBrandListController.formik.errors.DESCRICAO,
							'popup-form-inactive': !(
								getBrandListController.formik.touched.DESCRICAO &&
								getBrandListController.formik.errors.DESCRICAO
							),
						})}>
						{getBrandListController.formik.errors.DESCRICAO}
					</div>
				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getBrandListController.deleteDialog}
				onHide={handleBrandListController.closeDeleteDialog}
				footer={deleteBrandDialogFooter}
				header='Remover marca'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getBrandListController.selectedBrand && (
						<span>
							Você tem certeza que deseja deletar a marca{' '}
							<b>{getBrandListController.selectedBrand.DESCRICAO}</b>?
						</span>
					)}
				</div>
			</Dialog>
		</div>
	);
};

export default BrandsList;
